export default {
  title: 'Job Offers',
  create_offer_button: 'Create a new job offer',
  create_offer_title: 'Create a new job offer',
  create_offer_description:
    'Hire a passionate person for a key project. Create your job offer now and make the difference!',
  published_jobs_title: 'My published job offers',
  steps_previous: 'Previous step',
  steps_next: 'Next step',
  breadcrumb_dashboard: 'Dashboard',
  breadcrumb_manager: 'Project Managers',
  breadcrumb_jobs: 'Job Offers',
  publish_job_title: 'Publish your job offer',
  create_job_title: 'Create new job offer',
  wizard: {
    progress: 'Step {{current}} of {{total}}: {{step}}',
    steps: {
      details: 'Details',
      duration: 'Duration',
      recruitment: 'Recruitment',
      review: 'Review',
      payment: 'Payment & confirmation',
    },
    select_services: 'Select services',
    loading_choices: 'Loading choices…',
    quote_submission_deadline: 'Quote submission deadline',
    expected_response_date: 'Expected response date (optional)',
    listing_priority_help: 'Choose how prominently your offer appears.',
    selected_listing_priority: 'Selected',
    loading_listing_priorities: 'Loading listing priorities…',
    no_listing_priorities: 'No listing priorities are currently available. Retry after reloading.',
    credit_count_one: '{{count}} credit',
    credit_count_other: '{{count}} credits',
    create_on_behalf_of: 'Create on behalf of (optional)',
    loading_recruiters: 'Loading recruiters…',
    no_shadow_recruiter: 'No shadow recruiter',
    ready_to_publish: 'Ready to publish',
    ready_to_save_draft: 'Ready to save draft',
    admin_draft_help: 'This administrator-created job will be saved as an unpublished draft.',
    shadow_publish_help: 'This shadow-recruiter listing is published without consuming credits.',
    credit_publish_help: 'This will use {{cost}} credits. Your balance is {{balance}}.',
    insufficient_credits:
      'You need more credits. Purchase credits from your wallet, then return here to continue.',
    validation: {
      complete_required_details: 'Complete all required details before continuing.',
      choose_listing_priority: 'Choose a listing priority.',
      expires_at_before_today: 'The quote deadline must be today or later.',
      expires_at_after_start_date: 'The quote deadline cannot be after the project start date.',
      selection_date_before_expires_at:
        'The expected response date must be after the quote deadline.',
      selection_date_after_start_date:
        'The expected response date cannot be after the project start date.',
      start_date_before_today: 'The start date must be today or later.',
      end_date_before_start_date: 'The end date cannot be before the start date.',
    },
    actions: {
      discard_draft: 'Discard draft',
      back: 'Back',
      next: 'Next',
      publishing: 'Publishing…',
      confirm_publish: 'Confirm and publish',
      saving_draft: 'Saving draft…',
      save_draft: 'Save draft',
    },
  },
  create_job_button: 'Create my job offer',
  edit_job_button: 'Edit my job offer',
  publish_job_button: 'Publish my job offer',
  change_priority_button: 'Change display priority',
  save_and_publish: 'Save and Publish',
  jobStatus: 'Status',
  budget: 'Budget',
  remove_offer: 'Remove',
  cancel_changes: 'Cancel changes',
  service_type: 'Required service type(s)',
  wallet: 'My Wallet',
  credits: 'My Tokens',
  manage: 'Manage',
  back_to_job: 'Back to project',
  back_to_jobs: 'Back to my Job Offers',
  close_and_back_to_my_offers: 'Close and back to my offers',
  manage_jobs: 'Manage my job offers',
  job_published: 'Job offer published',
  job_updated: 'Job offer updated',
  job_hint: 'Your offer <strong>{{name}}</strong> is now visible on the offer search board.',
  published_at: 'Publication date',
  requested_at: 'Request date',
  expires_at: 'Quote Submission Deadline',
  expired_at: 'Quote submission deadline passed on',
  expired: 'Expired',
  reviewing_quotes: 'Reviewing quotes',
  selection_date: 'Expected Response Date',
  removed: 'Removed',
  description_label: 'Description',
  renewing: 'Renewing…',
  renew: {
    free: 'Renew (free)',
    success: 'Your project has been renewed for 14 days.',
    error: 'Renewal failed. Please try again.',
    removed_notice:
      'This project has been removed from the job board. Create a new one to keep recruiting.',
    start_date_unavailable_notice:
      'This project can’t be renewed because its start date is too close. Update the start date to allow renewal.',
  },
  project_info: 'Project information',
  quote_counts: '{{count}} submision received',
  quote_counts_plural: '{{count}} submissions received',
  quote_requests: 'Quote Requests',
  bidders: 'Bidders',
  cancelled: 'Cancelled',
  paused: 'Paused',
  pause_offer: 'Pause this offer',
  reopen_offer: 'Reopen this offer',
  reopen_unavailable_notice:
    'This offer’s submission deadline passed while it was paused, so it can no longer be reopened directly. Contact support to bring it back.',
  reopening: 'Reopening…',
  pausing: 'Pausing…',
  starting_reviewing: 'Starting review…',
  reopen_job_success: 'Offer reopened successfully',
  reopen_job_error: 'Failed to reopen the offer',
  pause_job_success: 'Offer paused successfully',
  pause_job_error: 'Failed to pause the offer',
  start_reviewing_offer: 'Start reviewing quotes',
  start_reviewing_success: 'The project is now in the quote review period.',
  start_reviewing_error: 'Failed to switch the project to reviewing quotes.',
  no_quotes_to_review_notice: 'No quotes have been submitted for this offer yet.',
  viewJob: 'View job',
  viewProjectInfo: 'View details',
  apply_for_offer: 'Demonstrate interest',
  close_and_back: 'Close and return to projects',
  showContacts: 'Show contact details',
  already_submitted_warning: 'You have already created a submission for this project.',
  go_to_my_quotes: 'View my Submissions',
  go_to_my_quote: 'View my submission',
  findOffer: 'Find a Job',
  subtitle: 'A freelancer',
  searchPlaceholder: 'Enter a domain name or discipline',
  filter: 'Filter',
  sort: 'Sort',
  filterBy: 'Filter by',
  sortBy: 'Sort by',
  loadMore: 'Load more results',
  showResults: 'Show results',
  alphabetical: 'Alphabetical order',
  publishedAt: 'Publication date sort',
  rating: 'Rating',
  proximity: 'Proximity',
  addService: 'Add a service',
  addCity: 'Add a city',
  maximum: 'Maximum',
  sorts: {
    az: 'Alphabetical order (A to Z)',
    za: 'Alphabetical order (Z to A)',
    allianceAsc: 'Ascending',
    allianceDesc: 'Descending',
    proximity: 'Proximity',
    publishedAtDesc: 'Newest',
    publishedAtAsc: 'Oldest',
  },
  searchErrorMessage: 'An error occurred while searching. Please try again.',
  retry: 'Retry',
  contactSupport: 'If the problem persists, please contact support.',
  noResults: 'No project found.',
  refineSearch: 'Try refining your search criteria to get better results.',
  noJobs: "You haven't created any job offers yet.",
  cancel_job: 'cancel your job offer.',
  cancel_and_confirm: 'Confirm and cancel',
  cancel_job_hint:
    'Your offer <strong>{{name}}</strong> will be removed from the project search board. You will be able to republish it later.',
  cancel_job_error: 'Error cancelling job offer.',
  cancel_job_success: 'Your job offer has been successfully cancelled.',
  createQuoteErrorTitle: 'Error creating quote',
  createQuoteErrorHint: 'An error occurred while creating your quote. Please try again.',
  quotes_count_labels: {
    private_pending: 'Quote request pending',
    private_rejected: 'Quote request rejected',
    quote_counts_zero: 'No submision received',
    quote_counts_one: '{{count}} submision received',
    quote_counts_other: '{{count}} submissions received',
    public_draft: 'Draft',
    quote_accepted: 'Quote accepted',
    quote_rejected: 'Quote rejected',
    change_requested: 'Change requested',
    job_cancelled: 'Project cancelled',
    alliance_retired: 'Invitation withdrawn',
    quote_counts: '{{count}} submission(s)',
  },
  quoteAccepted: {
    title: 'Submision accepted',
    message:
      'Your project {{projectName}} is registered in the Project Manager. {{freelancers}} will be notified.',
    returnToJobs: 'Return to my Job Offers',
  },
  rejectQuote: {
    title: 'Decline the submision',
    message:
      'To decline the submision, please provide a brief message to the freelancers. They may propose a new offer if they wish.',
    label: 'Your message for {{name}}',
    placeholder: 'Enter your message',
    cancel: 'Cancel and return to offer',
    send: 'Send',
    success: {
      title: 'submision declined',
      message:
        'Your project remains active in your Job Offers. <bold>{{freelancers}}</bold> will be notified. They may propose a new offer if they wish.',
      returnToJobs: 'Return to my Job Offers',
    },
  },
  viewProject: 'View project',
  publish: {
    priority_title: 'Display Priority',
    priority_help:
      'You can prioritize the display of your ad to more easily recruit freelancers for your project. You have three priority levels with a different cost for each.',
    expires_at_title: 'Quote Submission Deadline (inclusive)',
    expires_at_help: 'Your offer will no longer accept new submissions after this date',
    expires_at_before_today_error: 'The quote deadline must be today or later.',
    expires_at_after_start_date_error:
      'The quote submission deadline cannot be after the project start date ({{startDate}})',
    selection_date_title: 'Expected Response Date (optional)',
    selection_date_help:
      'Let freelancers know from which date you will start reviewing submitted quotes.',
    selection_date_before_expires_at_error:
      'The expected response date must be after the quote submission deadline',
    selection_date_after_start_date_error:
      'The expected response date cannot be after the project start date ({{startDate}})',
    use_credits_and_publish: 'Use {{count}} token and publish',
    use_credits_and_publish_plural: 'Use {{count}} tokens and publish',
    use_credits_and_modify: 'Use {{count}} credit and edit',
    use_credits_and_modify_plural: 'Use {{count}} credits and edit',
    loading: 'Loading...',
    edit: 'Edit',
    cancel: 'Cancel',
    priorities: {
      standard: {
        label: 'Standard',
        description: 'Chronological display.',
        details: 'Standard (cost = {{count}} tokens)',
      },
      featured: {
        label: 'Featured',
        description: 'Top-of-page display for 48 hours.',
        details: 'Featured (cost = {{count}} tokens)',
      },
      urgent: {
        label: 'Urgent',
        description:
          'Top-of-page display for 7 days with visual distinction. Matching freelancers within a 50km radius are automatically notified.',
        details: 'Urgent (cost = {{count}} tokens)',
      },
    },
    success: 'Your job offer has been successfully published.',
    error: 'Error publishing job offer.',
    already_published_error: 'This job has already been published.',
  },
  form: {
    project_name: 'Project Name',
    project_name_placeholder: 'Enter your project name',
    project_name_help:
      "Choosing a project name is a crucial step that can influence the perception and success of your initiative. A good name should be memorable, reflect the essence of the project, and resonate with your target audience. Consider words that evoke positive emotions or images, and don't hesitate to play with word combinations to create something unique.",
    location: 'Location',
    location_placeholder: 'Montreal',
    location_help:
      'Where will your project take place? By default, the city listed in your profile will be displayed.',
    price_range: 'Your budget',
    budget_placeholder: '$0',
    description: 'Project Description',
    description_placeholder: 'Describe your project...',
    service_type: 'Add service type(s)',
    service_type_placeholder: 'Add service type(s)',
    service_type_help:
      "When selecting the types of services needed for your project, it's essential to understand the specific needs of your initiative. Start by identifying the main objectives and expected results. Then, assess the available resources and your team's skills. Consider services such as web development, digital marketing, or project management, depending on what best supports your vision. Finally, don't forget to consider feedback from similar projects to refine your choice.",
    onsite: 'On-site work',
    onsite_no: 'No',
    languages: 'Spoken language(s)',
    start_date: 'Requested start date',
    end_date: 'Requested project end date',
    submit: 'Create job offer',
    submitting: 'Creating job offer...',
    error_required: 'Please fill in all required fields.',
    error_budget: 'Maximum budget must be greater than minimum.',
    error_create: 'Error creating job offer.',
    error_date_must_be_future: 'The start date must be in the future.',
    error_end_date_before_start: 'The due date must be after the start date.',
    complete_required_fields: 'Please complete all required fields',
  },
  request_quote_modal: {
    title: 'Request a submission from {{freelancer}}',
    sent_title: 'Submission request sent',
    sent_message:
      'Your submission request was sent to {{freelancer_name}}. You can manage this request in your projects.',
    see_my_jobs: 'View my submission requests',
    close_and_return_to_profile: 'Close and return to profile',
    error:
      'An error occurred while sending the submission request. Please try again or contact support.',
  },
  job_visibility_labels: {
    private: 'Submission request',
    public: 'Project',
  },
  bigSteps: {
    title: 'Key steps',
    subtitle: 'Get started quickly with the essentials',
    steps: {
      one: {
        title: 'Describe your project',
        description: 'Explain your needs, the type of mandate, and the required skills.',
      },
      two: {
        title: 'Add key details',
        description: 'Budget, timeline, important dates, and collaboration mode.',
      },
      three: {
        title: 'Post and receive proposals',
        description: 'Your project is visible to interested freelancers.',
      },
    },
    needHelp: 'Need help?',
    cta: 'Call to action',
  },
  edit_job_title: 'Edit job offer',
  alphabeticalSort: 'Alphabetical order',
  createdAtSort: 'Creation date',
} as const;
